import React from 'react';
import { Inline, Text } from '@atlaskit/primitives';
var AKLabel = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Label
    };
  });
});
export var Label = function Label(_ref) {
  var isRequired = _ref.isRequired,
    label = _ref.label,
    name = _ref.name;
  return /*#__PURE__*/React.createElement(AKLabel, {
    htmlFor: name,
    id: "".concat(name, "-label")
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.025"
  }, label, isRequired && /*#__PURE__*/React.createElement(Text, {
    as: "strong",
    color: "color.text.danger",
    size: "UNSAFE_small"
  }, "*")));
};